/* eslint-disable react/jsx-no-constructed-context-values */
import React, {
  createContext, useContext, useEffect, useState,
} from 'react';

const defaultPreferences = {
  timeFormat: '24h',
};

const PreferencesContext = createContext(null);

export const PreferencesProvider = ({ children }) => {
  const [state, setState] = useState(defaultPreferences);

  useEffect(() => {
    const localStoragePreferences = localStorage.getItem('preferences');
    if (localStoragePreferences) {
      setState(JSON.parse(localStoragePreferences));
    }
  }, []);

  const updatePreferences = (key, value) => {
    if (!(key in state)) {
      throw new Error(`Invalid preference key: ${key}`);
    }
    const newPreferences = { ...state, [key]: value };
    setState(newPreferences);
    localStorage.setItem('preferences', JSON.stringify(newPreferences));
  };

  return (
    <PreferencesContext.Provider value={{ state, updatePreferences }}>
      {children}
    </PreferencesContext.Provider>
  );
};

const usePreferencesContext = () => {
  const context = useContext(PreferencesContext);
  if (!context) {
    throw new Error('usePreferencesContext must be used within a PreferencesProvider');
  }
  return context;
};

export default usePreferencesContext;
